import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useSendProductRequest } from '@/application/send-product-request'

const COVER_BOOKING_URL = 'https://calendar.app.google/sx3gm9YqW3HQXQfi9'

export const CoverBanner = () => {
  const { t } = useTranslation()

  const email =
    useAppSelector((store) => store.userApi.getMe.response.user?.name) ?? ''

  const { sendProductRequest, success } = useSendProductRequest()

  const handleClickRequest = () => {
    // Opened synchronously in the click handler so popup blockers allow it.
    window.open(COVER_BOOKING_URL, '_blank', 'noopener')
    sendProductRequest({
      email,
      featureText: 'COVER',
      source: 'product-request'
    })
  }

  return (
    <div className="mb-5">
      <div className="relative flex w-full items-center overflow-hidden rounded-lg bg-shell text-white">
        <div className="y-5 -mt-0.5 flex flex-col items-center py-5 pl-6 pr-5">
          <span className="whitespace-nowrap text-center font-roobert text-[11px] font-semibold tracking-[0.5px] text-white/80">
            {t('cover_banner.introducing')}
          </span>
          <span className="animate-cover-shine whitespace-nowrap bg-[linear-gradient(100deg,#ffffff_35%,#A2EEFF_50%,#ffffff_65%)] bg-[length:250%_100%] bg-clip-text text-center font-marr-sans text-[45px] font-semibold italic leading-none tracking-[.03em] text-transparent">
            {t('cover_banner.name')}
          </span>
        </div>
        <span className="h-9 w-px bg-white/[.18]" />
        <div className="group relative flex min-w-0 flex-1 items-center gap-6 self-stretch overflow-hidden py-5 pl-6 pr-5">
          <div
            aria-hidden
            className="pointer-events-none absolute left-[92%] top-0 z-0 h-full w-[300px] -translate-x-1/2 animate-cover-glow-drift rounded-full bg-[radial-gradient(ellipse_220px_120px_at_center,rgba(23,144,255,.45),transparent_75%)] blur-xl transition-[left] duration-500 ease-out group-has-[button:hover]:left-[92%] group-has-[button:hover]:animate-none"
          />
          <div className="space-y-1">
            <p className="relative z-[1] font-roobert text-base font-semibold leading-5 text-white">
              {t('cover_banner.title')}
            </p>
            <p className="relative z-[1] font-roobert text-[13px] font-normal leading-[18px] text-white/80 [text-wrap:pretty]">
              {t('cover_banner.subtitle')}
            </p>
          </div>
          <button
            onClick={handleClickRequest}
            disabled={success}
            className="relative z-[1] h-fit cursor-pointer whitespace-nowrap rounded-full border border-white/40 bg-transparent px-5 py-2.5 font-roobert text-sm font-semibold text-white  transition-colors duration-200 hover:border-white hover:bg-white/10 disabled:cursor-default"
          >
            {success
              ? t('cover_banner.requested_short')
              : t('cover_banner.cta')}
          </button>
        </div>
      </div>
    </div>
  )
}
